export default __webpack_public_path__ + "static/media/strategy.d342bbd5.svg";